<template>
    <el-dialog title="新增角色" width="70%" :append-to-body="true" :visible.sync="newRoleVisible" center v-loading="newRoleLoading" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"	
    element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
        <el-form ref="newRoleForm" :rules="newRoleRules" :model="newRoleForm" label-width="180px" size="mini" >
            <el-form-item label="角色名称：" prop="role.roleName" >
                <el-input v-model="newRoleForm.role.roleName" placeholder="角色名称"  clearable :maxlength="20" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="角色描述：" prop="role.description">
                <el-input v-model="newRoleForm.role.description" placeholder="角色描述" clearable type="textarea" :maxlength="150" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="角色状态：" prop="role.status">
                <el-radio-group size="mini" v-model="newRoleForm.role.status">
                    <el-radio-button :label="0">正常</el-radio-button>
                    <el-radio-button :label="1">禁用</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="角色权限：" prop="rightList">
                <div class="rightDiv">
                    <el-transfer v-model="newRoleForm.rightList" :data="rightList" :props="{key: 'rightId',label: 'rightName'}"
                    :titles="['未含权限', '已含权限']"  :format="{noChecked: '${total}',hasChecked: '${checked}/${total}' }"
                    >
                        <span slot-scope="{ option }">
                        <el-tooltip :content="option.rightName+':('+option.notes+')'" placement="right" effect="light">
                            <span>{{ option.rightName }}</span> 
                        </el-tooltip>
                        </span>
                    </el-transfer>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="addNewRole">提交</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    name:'NewRole',
    props:{
        newRoleVisible:Boolean,
        flushRoleList:Function,
        rightList:Array,
    },
    data(){
        return {
            newRoleLoading:false,
            newRoleForm:{
                role:{
                    roleId:null,
                    roleName:"",
                    description:"",
                    createTime:null,
                    status:0,
                },
                rightList:[]
            },
            newRoleRules:{
                'role.roleName':[{required:true,message:"角色名称必填",trigger:'blur'}],
                'role.description':[{required:true,message:"角色描述必填",trigger:'blur'}],
                rightList:[{ type: 'array', required: true, message: '至少需要1个角色权限', trigger: 'change' }]
            }
        }
    },
    mounted(){},
    methods:{
        close(){
            this.$refs.newRoleForm.resetFields()
            this.$emit('changeVisible',false)
        },
        addNewRole(){
            this.$refs.newRoleForm.validate(async valid=>{
                if(valid){
                    var confirmresult=await this.$confirm('将要添加新的角色，请确定是否继续？','提示',{
                        confirmButtonText:'确定',cancelButtonText:'取消',type:'warning'
                    }).catch(err=>err)
                    if(confirmresult!=='confirm'){
                        return this.$message.info('操作已取消')
                    }else{
                        this.newRoleLoading=true
                        const {data:res}=await this.$http.post('role/add',this.newRoleForm).catch(err => err)
                        if(res){
                            this.$message.success('操作成功！')
                            this.flushRoleList()
                            this.close()
                        }
                        this.newRoleLoading=false
                    }

                }else{
                    return false
                }
            })
        },
    },
}
</script>
<style scope>
    .el-transfer-panel{
    width: 280px;
    }
    .el-transfer-panel__list.is-filterable{
    height: 280px;
    }
</style>